<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-employee :contactPageData='contactPage'></app-employee>
        <app-footer></app-footer>
    </div>
</template>

<script>


    // import { headers } from "../../config";
    import {listemployee, configs} from '../../config';

    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontFooter from '@/components/partials/FrontFooter';
    import {listEmployeeTable} from '../../config';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';
    import ListEmployeeComponent from "@/components/employee/ListEmployeeComponent";

    Vue.use(VueGoodTable);

    export default {
        name: "listemployee",
        components: {
            'app-employee': ListEmployeeComponent,
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        message: 'all',
        data: () => ({
            contactPage: {
                    pageTitle: 'Employee List',
                },
                isLoggedIn: false,
                
            }),
        mounted: function () {
            var self = this;
            // var userObj = localStorage.getItem('filters');
            /*if (userObj != null) {
             userObj = JSON.parse(userObj);
             if (userObj.menuemployee != null) {
             self.serverParams.columnFilters = userObj.menuemployee;
             $.map(userObj.menuemployee, function (val, key) {
             $.each(self.columns, function (i) {
             if (self.columns[i].field == key && val != '') {
             self.columns[i].filterOptions.filterValue = val;
             }
             });
             });
             }
             }*/
            $(".removeActive").removeClass('active');
            $("#menuemployee").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }


        }
    };
</script>


// WEBPACK FOOTER //
// src/components/employee/ListEmployee.vue